/**
 * @generated SignedSource<<de0286594ebb6c35f4e847b9379d1e11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
import { FragmentRefs } from "relay-runtime";
export type WidgetTaskSingleCheck_taskCheckOccasion$data = ReadonlyArray<{
  readonly id: string;
  readonly occasion: {
    readonly endAt: string;
    readonly startAt: string;
  };
  readonly taskExecutions: ReadonlyArray<{
    readonly checkValue: TaskSentiment | null;
    readonly sectionId: string;
  }>;
  readonly " $fragmentType": "WidgetTaskSingleCheck_taskCheckOccasion";
}>;
export type WidgetTaskSingleCheck_taskCheckOccasion$key = ReadonlyArray<{
  readonly " $data"?: WidgetTaskSingleCheck_taskCheckOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskSingleCheck_taskCheckOccasion">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "WidgetTaskSingleCheck_taskCheckOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineOccasion",
      "kind": "LinkedField",
      "name": "occasion",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskExecutionCheck",
      "kind": "LinkedField",
      "name": "taskExecutions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sectionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "checkValue",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TaskCheckOccasion",
  "abstractKey": null
};

(node as any).hash = "daec7a6ba933be0c80411e236a987958";

export default node;
